import React from 'react';
import useMediaQuery from '../../hooks/useMediaQuery';
import { TSocialMediaProps } from './types/index.types';
import { SocialMediaModel } from './models/index.model';
import RoutableSitecoreLink from '../@shared/routableSitecoreLink';
import breakpoints from '../../constants/breakpoints.constants';
import './index.scss';
import Icon from '../@shared/icon';
import { iconSize } from '../../constants/icon.constants';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { FieldEditFrameComponent } from '../@shared/editFrame';
import CustomExternalAnchor from '../@shared/customExternalAnchor';
import fields from '../../constants/fields.const';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import { targetLinkdsk } from '../../utils/targetDskLink';

const SocialMedia = (props: TSocialMediaProps): JSX.Element => {
  const model = new SocialMediaModel(props);
  const isWide = useMediaQuery(`(min-width: ${breakpoints['tbl-p']}px)`);
  const isEEActive = props?.sitecoreContext?.pageEditing;
  const socialIconSize = isWide ? iconSize.dsk : iconSize.mbl;

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  return (
    <>
      <div className="case-social-media">
        <div className="case-social-media__links-wrapper">
          {model.socialLinks.map((item) =>
            isEEActive ? (
              <div>
                <CustomExternalAnchor field={item.fields?.link} />
                <FieldEditFrameComponent itemId={item.id} fields={[fields.icon]} sitecoreContext={props?.sitecoreContext}>
                  <Icon iconField={item.fields?.icon} color={'primary'} size={iconSize.dsk} />
                </FieldEditFrameComponent>
              </div>
            ) : (
              <div className="case-social-media__social-icon-link-wrapper">
                <RoutableSitecoreLink
                  field={item.fields?.link}
                  target={targetLinkdsk(item?.fields?.link, isWide)}
                  className={'case-social-media__social-icon-link'}
                >
                  <Icon iconField={item.fields?.icon} color={'primary'} size={socialIconSize} />
                </RoutableSitecoreLink>
              </div>
            )
          )}
        </div>
        <div className="case-social-media__highlight-bar" />
      </div>
    </>
  );
};

export default withSitecoreContext()(SocialMedia);
